class SocialShare extends HTMLElement {
  siteHeader = null;
  mode = '';
  position = '';
  onWindowResizeBind = this.onWindowResize.bind(this);

  constructor() {
    super();

    this._onWindowResize = this.onWindowResize.bind(this);
  }

  connectedCallback() {
    this.siteHeader = document.querySelector('site-header');
    this.mode = this.getAttribute('data-socialshare-mode');
    this.position = this.getAttribute('data-socialshare-position');

    this.addEventListeners();
    this.onWindowResize();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    window.addEventListener('resize', this._onWindowResize);
  }

  removeEventListeners() {
    window.removeEventListener('resize', this._onWindowResize);
  }

  onWindowResize() {
    if (this.mode !== 'desktop' && this.position !== 'sticky') return;

    this.style.top = `${this.siteHeader?.offsetHeight ?? 0}px`;
  }
}

customElements.define('social-share', SocialShare);
